export default __webpack_public_path__ + "static/media/maze-portal.4ee7c6b4.svg";